module.exports = __webpack_public_path__ + "static/img/firecrackers.b866c75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/activity/gift/specific/firecrackers.png
// module id = 6kgj
// module chunks = 1